import * as React from "react";
import { cn } from "./utils";

interface SwitchFieldsetProps {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

const SwitchFieldset = ({
  label,
  required,
  children,
  className,
}: SwitchFieldsetProps) => {
  return (
    <fieldset
      className={cn(
        "w-full rounded-[0.6rem] border border-gray-300 bg-transparent px-3 pt-[2px] pb-[6px]",
        className
      )}
    >
      <legend className="px-1">
        <span className="text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </span>
      </legend>

      <div className="mt-2 flex items-center justify-between">
        {children}
      </div>
    </fieldset>
  );
};

export { SwitchFieldset };